export enum ActionType {
    WP_MAIN__RELOAD = 'WP_MAIN__RELOAD',
    WP_MAIN__RELOAD_RESULT = 'WP_MAIN__RELOAD_RESULT',
    WP_MAIN__EXPAND_ROW = 'WP_MAIN__EXPAND_ROW',
    WP_MAIN__EXPAND_ROW_RESULT = 'WP_MAIN__EXPAND_ROW_RESULT',
    WP_MAIN__EXPAND_ROW_CANCEL = 'WP_MAIN__EXPAND_ROW_CANCEL',
    WP_MAIN__SORT_ROWS = 'WP_MAIN__SORT_ROWS',
}
